
document.addEventListener('DOMContentLoaded', () => {
  const sparkleAt = (x, y) => {
    const sparkle = document.createElement('span');
    sparkle.className = 'marshello-sparkle';
    sparkle.textContent = Math.random() > 0.5 ? '✦' : '✧';
    sparkle.style.left = `${x}px`;
    sparkle.style.top = `${y}px`;
    document.body.appendChild(sparkle);
    window.setTimeout(() => sparkle.remove(), 750);
  };

  document.querySelectorAll('.mh-button, .button, .msp-button, .mcp-button, .mpp-button, .msp-shop-button')
    .forEach((button) => {
      button.addEventListener('click', () => {
        button.classList.remove('marshello-pop');
        void button.offsetWidth;
        button.classList.add('marshello-pop');
      });
    });

  const footerBadge = document.querySelector('.mh-footer__logo-image');
  if (footerBadge) {
    footerBadge.addEventListener('click', (event) => {
      footerBadge.classList.remove('marshello-spin');
      void footerBadge.offsetWidth;
      footerBadge.classList.add('marshello-spin');

      const rect = footerBadge.getBoundingClientRect();
      for (let i = 0; i < 5; i += 1) {
        window.setTimeout(() => {
          sparkleAt(
            rect.left + rect.width * (0.2 + Math.random() * 0.6),
            rect.top + rect.height * (0.2 + Math.random() * 0.6)
          );
        }, i * 70);
      }
    });
  }

  const headerBrand = document.querySelector('.mh-header__brand');
  if (headerBrand) {
    let hoverCount = 0;

    headerBrand.addEventListener('mouseenter', () => {
      hoverCount += 1;
      if (hoverCount % 5 === 0) {
        const rect = headerBrand.getBoundingClientRect();
        sparkleAt(rect.right - 6, rect.top + 10);
      }
    });
  }
});
